import moment from 'moment/moment';
import numeral from "numeral";

const service = function(numberFormat = "0,0.00", decimalSeparator = ".") {
  service.locale = navigator.languages[0];
  service.dateFormat = "DD.MM.YYYY";
  service.dateTimeFormat = "DD.MM.YYYY HH:mm:ss";
  service.inputDateFormat = "D.M.YYYY";
  service.systemDateFormat = "YYYY-MM-DDTHH:mm:ss";
  numeral.defaultFormat = numberFormat
  return {
    formatNumber(number, numberFormat) {
      return numeral(number).format(numberFormat)
    },
    formatAmount(number) {
      return numeral(number).format("0,0.00");
    },
    formatDate(value, strict = true) {
      return moment(value, service.systemDateFormat, strict).format(service.dateFormat);
    },
    formatDateTime(value, strict = true) {
      return moment(value, service.systemDateFormat, strict).format(service.dateTimeFormat);
    },
    parseDate(value, strict = true) {
      return moment(value, service.inputDateFormat, strict).format(service.systemDateFormat);
    },
    processDateFormula(value, originalDate) {
      let validatePart = (part) => {
        let regexp = /((\+|-)?[0-9]+)(d|w|wd|m|sow|eow|som|eom|soy|eoy)/; //dodat soq
        let matched = part.match(regexp);
        let isValid = matched && part == matched[0];
        return isValid == null ? false : isValid;
      }
      let parts = value.split(">");
      let isValidFormula = parts.map(validatePart).reduce((prev, curr) => prev && curr, true);

      originalDate = moment(originalDate);

      const adjustEnd = (amt) => amt > 0 ? amt - 1 : amt;
      const adjustStart = (amt) => amt < 0 ? amt + 1 : amt;

      let quantifiers = {
        d(amount, date) {
          return date.add(amount, "day");
        },
        w(amount, date) {
          return date.add(amount, "weeks");
        },
        m(amount, date) {
          return date.add(amount, "months");
        },
        sow(amount, date) {
          return date.add(adjustStart(amount) * 7, "days").startOf("isoWeek");
        },
        eow(amount, date) {
          return date.add(adjustEnd(amount) * 7, "days").endOf("isoWeek");
        },
        som(amount, date) {
          return date.add(adjustStart(amount), "months").startOf("month");
        },
        eom(amount, date) {
          return date.add(adjustEnd(amount), "months").endOf("month");
        },
        soy(amount, date) {
          return date.add(adjustStart(amount), "year").startOf("year");
        },
        eoy(amount, date) {
          return date.add(adjustEnd(amount), "year").endOf("year");
        }
      }

      if(isValidFormula) {
        let getAmount = (val) => Number.parseInt(val.match(/((\+|-)?[0-9]+)/)[0]);
        let applyQuantifier = (date, val) => quantifiers[val.match(/([a-z]+)/)[0]](getAmount(val), date);

        return parts.reduce((prev, curr) => applyQuantifier(prev, curr), originalDate)
      }
      else {
        return "Invalid formula";
      }
    }
  }
};

export default service;
